import { render } from "./AutosizeTextarea.vue?vue&type=template&id=6ddcd80a"
import script from "./AutosizeTextarea.vue?vue&type=script&lang=ts"
export * from "./AutosizeTextarea.vue?vue&type=script&lang=ts"
script.render = render

export default script